import React from 'react';
import ViewMessage from '@components/ViewMessage';
import { ActionArchiveIcon } from '@components/Icons';

export default function EmptyArchive() {
  return (
    <ViewMessage
      underHeader
      icon={<ActionArchiveIcon hoverOpacity={false} />}
      headline="Archive"
      message={
        <>
          Once you archive someone,
          <br />
          You'll see them here
        </>
      }
    />
  );
}
